import { render } from "./F4NBiomassIcon.vue?vue&type=template&id=122e8d21"
import script from "./F4NBiomassIcon.vue?vue&type=script&lang=js"
export * from "./F4NBiomassIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__